module.exports = "<dl class=\"form-element\">\n    <dt>\n        <label>Klient</label>\n    </dt>\n    <dd>\n        <select\n            ng-class=\"IssueFormClientsCtrl.isFullWidth ? 'full-width' : ''\"\n            name=\"company\"\n            ng-model=\"IssueFormClientsCtrl.client\"\n            ng-options=\"item as item.name for item in IssueFormClientsCtrl.dataFromBackend track by item.party_uuid\"\n        >\n            <option value=\"\">Wybierz klienta</option>\n        </select>\n    </dd>\n</dl>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/issues/issue_forms/fragments/clients/issue_form_clients.html
// module id = 649
// module chunks = 0